import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-h4-bold-light",
  "use": "icon-h4-bold-light-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-h4-bold-light\">\n<path d=\"M2.22498 6.06396V18.916H4.33098V13.228H10.847V18.916H12.953V6.06396H10.847V11.428H4.33098V6.06396H2.22498Z\" fill=\"#007AF5\" />\n<path d=\"M19.645 11.7959L16.155 16.2959V17.4059H19.605V18.9359H20.715V17.4059H21.775V16.4759H20.715V11.7959H19.645ZM19.575 13.2759H19.605V16.4759H17.105L19.575 13.2759Z\" fill=\"#007AF5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol